module.exports = __webpack_public_path__ + "static/icon-digitalization.8a3e6541.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-digitalization.svg
// module id = 197
// module chunks = 35783957827783 267625579013595